// Load polyfills as the first thing
import 'babel-polyfill';

import React from 'react';
import { render } from 'react-dom';
import { createStore, applyMiddleware } from 'redux';
import { Provider } from 'react-redux';
import thunk from 'redux-thunk';
import { composeWithDevTools } from 'redux-devtools-extension';
import reducer from './reducer';
import dtmTagging from './middleware/dtmTagging';
import clearReduxFormValueOnUnregister from './middleware/clearReduxFormValueOnUnregister';
import AppRoutes from './components/appRoutes';
import ErrorBoundary from './components/errorBoundary';
import { BrowserRouter as Router } from 'react-router-dom';
import { parseQueryString } from './utils/formatters';

import './assets/css/main.scss';
import './assets/images/barclays-landscape_logo.gif';
import './assets/images/barclays-logo.svg';
import './assets/images/landing-background.jpg';
import './assets/images/modal-lightbox.png';
import './assets/images/session-timeout.svg';

const initialState = () => {
  const campaignDefaults = window.envConfig && window.envConfig.campaignDefaults ? window.envConfig.campaignDefaults : { minApr: "4.99", maxApr: "18.99", paymentAmount: 231 };
  const campaign = window.envConfig && window.envConfig.campaign ? window.envConfig.campaign : { minApr: "5.74", maxApr: "18.99", campaignId: 'campaignId', cellId: 'cellId', minLoanAmount: "5000", maxLoanAmount: "35000" };
  const veridConfig = window.envConfig && window.envConfig.veridConfig ? window.envConfig.veridConfig : { initialWait: 3000, retryCount: 8, retryDelay: 1000, fetchAppStatusWait: 5000 };
  const tagEvent = parseQueryString(window.location.search.toString()).tagEvent;
  const siteName = parseQueryString(window.location.search.toString()).site_name;
  const affiliateName = parseQueryString(window.location.search.toString()).affiliate_name;
  const refId = window.digitalData ? window.digitalData.pageInfo.referrerId : "";
  const publisherId = parseQueryString(window.location.search.toString()).publisherid;
  const advertisementId = parseQueryString(window.location.search.toString()).advertisementid;
  const shopperId = parseQueryString(window.location.search.toString()).shopperid;
  const creditCardApplicant = window.envConfig.creditCardApplicant;

  const featureToggles = {};
  window.isToggleOn = window.isToggleOn ? window.isToggleOn : function(toggle){ return featureToggles[toggle]; };
  window.isToggleOff = window.isToggleOff ? window.isToggleOff : function(toggle){ return !featureToggles[toggle]; };

  let dtmData = {
    pageInfo: { referrerId: refId, siteName: siteName || "", affiliateName: affiliateName || "" }
  };
  if (window.isToggleOn('cj_integration')) {
    dtmData.cjTagEvent = tagEvent || "";
    dtmData.publisherId = publisherId || "";
    dtmData.advertisementId = advertisementId || "";
    dtmData.shopperId = shopperId || "";
  }

  return {
    step: 'landing',
    envConfig: {
      campaignDefaults,
      veridConfig,
      campaign
    },
    dtm: dtmData,
    creditCardApplicant: creditCardApplicant
  };
};

const store = createStore(
  reducer,
  initialState(),
  composeWithDevTools(applyMiddleware(thunk, dtmTagging, clearReduxFormValueOnUnregister))
);

render(
  <Provider store={store}>
    <ErrorBoundary>
      <Router>
        <AppRoutes/>
      </Router>
    </ErrorBoundary>
  </Provider>,
  document.getElementById('app')
);
